import React from "react"

function getStatusString(status) {
  switch (status) {
    case "paid":
      return "paid"
    case "unpaid":
      return "unpaid"
    case "partial":
      return "partially paid"
    case "cancelled":
      return "cancelled"
    case "refunded":
      return "refunded"
    default:
      break
  }
}

export default function({
  orderNumber,
  paymentStatus,
  paymentDetail,
  isRefunded
}) {
  return (
    <div className="order-number space-between">
      <span className="bold">Order #{orderNumber}</span>
      {(paymentDetail &&
        paymentDetail.state === "For Verification" &&
        !isRefunded && (
          <span className="for-verification">{paymentDetail.state}</span>
        )) || (
        <span className={`${paymentStatus.replace(" ", "")}`}>
          {getStatusString(paymentStatus)}
        </span>
      )}
    </div>
  )
}
